import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MessageErrorResolver } from '../../utilities/message-error-resolver';
import { LoadingService } from './loading.service';
import { EMPTY, Observable, catchError, map } from 'rxjs';
import { IPage } from '../../models/pagination/page';
import { ResponseDto, ResponseWithErrorDto } from '../../models/exceptions/response-dto';
import { IPositionDto } from '../../models/position-dto';

@Injectable({
  providedIn: 'root'
})
export class PositionService {
  
  private url: string = environment.apiUrl + "/v1/cargos";

  constructor(
    private httpClient: HttpClient,
    private messageErrorResolver: MessageErrorResolver,
    private loadingService: LoadingService
  ) { }

  public findAll(): Observable<IPage<IPositionDto>> {
    return this.httpClient.get<ResponseDto<IPage<IPositionDto>>>(`${this.url}`)
    .pipe(
      map(response => response.response),
      catchError((error: ResponseWithErrorDto) => {
        this.loadingService.deactivate();
        this.messageErrorResolver.resolveMessage(error);
        return EMPTY;
      })
    );
  }
}
